var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"discount-selection"},[_c('p',{staticClass:"discount-selection-title"},[_vm._v("暂无优惠")])])
}]

export { render, staticRenderFns }